import React from 'react';
import { Layout, Row, Col, Input, Button as AntButton } from 'antd';
import { withRouter } from 'react-router-dom';

import BadgeIos from '../../resources/img/badge_ios.svg';
import BadgeItch from '../../resources/img/badge_itch.svg';
import Logo from '../../resources/img/madfactory_title.png';
import Left from '../../resources/img/left.png';
import MF_BG from '../../resources/img/madfactory_thumb.png';
import Button from '../components/Button';
import Footer from '../components/Footer';
import { notifyAccessDemo, notifyAccessMain, notifyAccessMarket } from '../services/demoService';

const { Header, Content } = Layout;
const { Search } = Input;

class MadFactory extends React.Component {
    constructor(props) {
        super(props);

        this.state = {

        }


        this._onPlayDemo = this._onPlayDemo.bind(this);
        // this._onConfirm = this._onConfirm.bind(this);
        this._onGenerateCode = this._onGenerateCode.bind(this);
    }

    componentDidMount() {
        notifyAccessMain('mad-factory');
    }

    // _onConfirm(value) {
    //     if(value === '') return;
    //
    //     this.props.history.push("/madFactory/demo/" + value);
    // }

    _onPlayDemo() {
        this.props.history.push("/madFactory/demo");
    }

    _onClickDownload(market) {
        notifyAccessMarket('mad-factory', market);
    }


    _onGenerateCode() {
        // code
        // generateCode({name:'Steven Aang', platform: "facebook"})
        //     .then((res) => {
        //         console.log(res);
        //     });

        // code w/ text
        // generateCodeWithText({name:'sunwoo', platform: "kakao"})
        //     .then((res) => {
        //         console.log(res);
        //     });
    }


    render() {
        return (
            <Layout className={'fadeIn full-layout mad-factory'}>
                <div className={'mad-factory__bg-box'}>
                    <img src={MF_BG} alt="" className={'mad-factory__bg'}/>
                </div>
                <Header className={'header work-header'}>
                    <div className={'work-header__title'}>
                        <Button icon={Left} className={'work-header__back'} onClick={() => this.props.history.push('/')}/>
                        <img className={'work-header__title__img'} src={Logo} alt="logo"/>
                    </div>
                </Header>
                <Content className={'mad-factory__content-box'}>
                    <div className={'mad-factory__content mad-factory__content--center'}>
                        <Row justify={'center'} align={'middle'}>
                            <Col span={6}>
                                <div className={"mad-factory__demo"}>
                                    <p className={"mad-factory__demo__title"}>PLAY DEMO</p>
                                    {/*<Search*/}
                                        {/*placeholder="Enter demo code"*/}
                                        {/*allowClear*/}
                                        {/*enterButton="Play"*/}
                                        {/*size="large"*/}
                                        {/*onSearch={this._onConfirm}*/}
                                    {/*/>*/}
                                    <AntButton block size={'large'} type={'primary'} onClick={this._onPlayDemo}>PLAY</AntButton>
                                </div>
                            </Col>
                            <Col span={24}>
                                <div className={'mad-factory__download-box'}>
                                    <a target={'blank'} onClick={()=> this._onClickDownload('play-store')} href='https://play.google.com/store/apps/details?id=com.Dev09.MadFactory&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1'>
                                        <img className={'mad-factory__download-icon mad-factory__download-icon--android'} alt='Get it on Google Play' src='https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png'/>
                                    </a>
                                </div>
                            </Col>
                            <Col span={24}>
                                <div className={'mad-factory__download-box'}>
                                    <a target={'blank'} onClick={() => this._onClickDownload('app-store')} href="https://apps.apple.com/us/app/mad-factory-the-escape/id1551262057">
                                        <img className={'mad-factory__download-icon mad-factory__download-icon--ios'} alt='Download on the App Store' src={BadgeIos}/>
                                    </a>
                                </div>
                            </Col>
                            <Col span={24}>
                                <div className={'mad-factory__download-box'}>
                                    <a target={'blank'} onClick={() => this._onClickDownload('itch.io')} href="https://dev09.itch.io/mad-factory">
                                        <img className={'mad-factory__download-icon mad-factory__download-icon--itch'} alt='Download on itch.io' src={BadgeItch}/>
                                    </a>
                                </div>
                            </Col>
                        </Row>
                    </div>
                    {/*<div className={'mad-factory__content mad-factory__content--center'}>*/}
                        {/*/!*<AntButton onClick={this._onGenerateCode}>Generate</AntButton>*!/*/}
                        {/*<div className={"mad-factory__demo"}>*/}
                            {/*<p className={"mad-factory__demo__title"}>PLAY DEMO</p>*/}
                            {/*<Search*/}
                                {/*placeholder="Enter demo code"*/}
                                {/*allowClear*/}
                                {/*enterButton="Play"*/}
                                {/*size="large"*/}
                                {/*onSearch={this._onConfirm}*/}
                            {/*/>*/}
                        {/*</div>*/}
                    {/*</div>*/}

                    {/*<div className={'mad-factory__content mad-factory__content--center'}>*/}
                        {/*<Row justify={'center'} align={'middle'}>*/}
                            {/*<Col lg={24} sm={6} xs={24}>*/}
                                {/*<div className={'mad-factory__download-box'}>*/}
                                    {/*<a target={'blank'} href="https://apps.apple.com/us/app/cube-fit-swipe-roll/id1521303073?mt=8">*/}
                                        {/*<img className={'mad-factory__download-icon mad-factory__download-icon--ios'} alt='Download on the App Store' src={BadgeIos}/>*/}
                                    {/*</a>*/}
                                {/*</div>*/}
                            {/*</Col>*/}
                            {/*<Col lg={24} sm={6} xs={24}>*/}
                                {/*<div className={'mad-factory__download-box'}>*/}
                                    {/*<a target={'blank'} href="https://apps.apple.com/us/app/cube-fit-swipe-roll/id1521303073?mt=8">*/}
                                        {/*<img className={'mad-factory__download-icon mad-factory__download-icon--itch'} alt='Download on the App Store' src={BadgeItch}/>*/}
                                    {/*</a>*/}
                                {/*</div>*/}
                            {/*</Col>*/}
                            {/*<Col lg={24} sm={6} xs={24}>*/}
                                {/*<div className={'mad-factory__download-box'}>*/}
                                    {/*<a target={'blank'} href='https://play.google.com/store/apps/details?id=com.Dev09.CubeFit&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1'>*/}
                                        {/*<img className={'mad-factory__download-icon'} alt='Get it on Google Play' src='https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png'/>*/}
                                    {/*</a>*/}
                                {/*</div>*/}
                            {/*</Col>*/}
                        {/*</Row>*/}
                    {/*</div>*/}
                </Content>
                <Footer/>
            </Layout>
        );
    }
}

export default withRouter(MadFactory);